import React from 'react';
import './Credits.css';

function Credits() {
  return (
    <div className="credits-page">
      <div className="credits-container">
        <h1 className="credits-title">Credits & Acknowledgments</h1>

        <div className="credits-section">
          <h2>Development Team</h2>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-avatar">👤</div>
              <h3>0b.livion</h3>
              <p className="member-role">Founder & Lead Developer</p>
              <p className="member-bio">
                Creator and primary developer of NitroDrop. Responsible for architecture, 
                backend development, and overall platform management.
              </p>
            </div>
            <div className="team-member">
              <div className="member-avatar">👤</div>
              <h3>Co-Founder</h3>
              <p className="member-role">Co-Founder & Developer</p>
              <p className="member-bio">
                Co-founder and developer contributing to platform development and features.
              </p>
            </div>
          </div>
        </div>

        <div className="credits-section">
          <h2>Technologies & Libraries</h2>
          <div className="tech-credits">
            <div className="tech-category">
              <h3>Frontend</h3>
              <ul>
                <li><strong>React.js</strong> - UI framework</li>
                <li><strong>React DOM</strong> - DOM rendering</li>
                <li><strong>CSS3</strong> - Styling</li>
              </ul>
            </div>
            <div className="tech-category">
              <h3>Backend</h3>
              <ul>
                <li><strong>Node.js</strong> - Runtime environment</li>
                <li><strong>Express.js</strong> - Web framework</li>
                <li><strong>MongoDB</strong> - Database</li>
                <li><strong>Mongoose</strong> - ODM</li>
                <li><strong>WebSocket</strong> - Real-time communication</li>
              </ul>
            </div>
            <div className="tech-category">
              <h3>Security & Auth</h3>
              <ul>
                <li><strong>bcryptjs</strong> - Password hashing</li>
                <li><strong>jsonwebtoken</strong> - JWT authentication</li>
                <li><strong>CORS</strong> - Cross-origin resource sharing</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="credits-section">
          <h2>Special Thanks</h2>
          <ul className="thanks-list">
            <li>All our users and community members for their support and feedback</li>
            <li>Discord for providing the platform that inspired this project</li>
            <li>Open source community for the amazing tools and libraries</li>
            <li>Beta testers who helped improve the platform</li>
            <li>Contributors and supporters of the project</li>
          </ul>
        </div>

        <div className="credits-section">
          <h2>Open Source</h2>
          <p>
            NitroDrop uses various open-source technologies and libraries. We are grateful 
            to all the developers and maintainers who make these tools available to the community.
          </p>
        </div>

        <div className="credits-section">
          <h2>License</h2>
          <p>
            NitroDrop is a proprietary platform. All rights reserved. This platform is not 
            affiliated with Discord, Inc. or any related entity.
          </p>
        </div>

        <div className="credits-section">
          <h2>Contact</h2>
          <p>
            For questions, suggestions, or contributions, please join our Discord server 
            or contact us through the platform.
          </p>
          <a 
            href="https://discord.gg/RXVZZWzMcq" 
            target="_blank" 
            rel="noopener noreferrer"
            className="discord-link-btn"
          >
            Join Discord Server
          </a>
        </div>

        <div className="credits-footer">
          <p>&copy; {new Date().getFullYear()} NitroDrop. All rights reserved.</p>
          <p>Made with ❤️ by the NitroDrop Team</p>
        </div>
      </div>
    </div>
  );
}

export default Credits;

